import { useMutation, useQueryClient } from "@tanstack/react-query";
import { restoreAcademicTerm as apiRestore } from "../../api/apiAcademicTerms";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useRestoreAcademicTerm() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: restoreAcademicTerm, isPending: isRestore } = useMutation({
        mutationFn: (id) => apiRestore(id),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["academicTerms"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { restoreAcademicTerm, isRestore };
}
